var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-update",class:[_vm.isLoading && 'loading']},[(_vm.isSubmit)?_c('a-spin'):_c('div',{staticClass:"content"},[_c('p',{domProps:{"textContent":_vm._s(_vm.$t('label.uploading'))}}),_c('p',[_vm._v(_vm._s(_vm.type))]),_c('a-progress',{attrs:{"type":"circle","width":50,"stroke-color":{
        '0%': '#108ee9',
        '100%': '#87d068',
      },"percent":_vm.percent}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }